import { FormikConsumer } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';

import './FormDebug.scss';

/**
 * @param  {string} theme - Is fed by parent Form
 */

class FormDebug extends React.Component {
  static propTypes = {
    theme: PropTypes.string,
  };
  render() {
    const { theme } = this.props;
    const formDebugClasses = createBEM('FormDebug', {
      [theme]: !!theme,
    });
    return (
      <div className={formDebugClasses}>
        <div className='FormDebug__header'>Formik State</div>
        <FormikConsumer>
          {({ validationSchema, validate, onSubmit, ...rest }) => (
            <pre className='FormDebug__text'>{JSON.stringify(rest, null, 2)}</pre>
          )}
        </FormikConsumer>
      </div>
    );
  }
}

export default FormDebug;
